define('SageDotCom/DataLayer/Events/SolutionFinder/solutionFinderGo',[
        "jquery",
        "SageDotCom/DataLayer/Events/eventBase"
    ],
    function ($, EventBase) {

        function SolutionFinderGoEvent() {
            EventBase.call(this); // inherit eventBase
            this.name = "button_click"; // overwrite name
        }

        SolutionFinderGoEvent.prototype = Object.create(EventBase.prototype);

        SolutionFinderGoEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(industry, companySize) {
            const eventType = "nova_go_{INDUSTRY}_{COMPANY-SIZE}";
            var whitespaceRegex = /\s+/g;
            var friendlyIndustry = industry !== "#" ? industry.trim().replace(new RegExp(whitespaceRegex), "_") : "industry";
            var friendlyCompanySize = companySize !== "#" ? companySize.trim().replace(new RegExp(whitespaceRegex), "_") : "company_size";
            var text = eventType.replace("{INDUSTRY}", friendlyIndustry).replace("{COMPANY-SIZE}", friendlyCompanySize);

            var eventData = {
                'event_name': this.getName(),
                'element_text': text
            }
            return eventData;
        }
        return new SolutionFinderGoEvent();
    });
